import { render } from "./personal-detail.vue?vue&type=template&id=153919be"
import script from "./personal-detail.vue?vue&type=script&lang=js"
export * from "./personal-detail.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__